import * as React from 'react'
import * as css from './ManualInputs.module.css'
import { calculatorStore } from './store'
import Slider from './Slider'
import TermSelection from './TermSelection'

export default function ManualInputs() {
  const {
    deposit,
    setDeposit,
    annuityRate,
    setAnnuityRate,
    taxRate,
    setTaxRate,
  } = calculatorStore()

  return (
    <fieldset className={css.root}>
      <div className={css.inputs}>
        <Slider
          label="Deposit"
          id="deposit"
          value={deposit.toLocaleString()}
          onInputChange={(e) => {
            const value = e.target.value.replace(/,/g, '')
            setDeposit(Number(value))
          }}
          min={0}
          maxLength={9}
          rangeProps={{
            step: 10_000,
            max: 2_000_000,
          }}
          prefix="$"
        />
        <Slider
          label="Annuity Rate"
          id="annuity-rate"
          value={annuityRate}
          onInputChange={(e) => setAnnuityRate(e.target.value)}
          min={0}
          max={100}
          rangeProps={{
            step: 0.1,
            max: 20,
          }}
          suffix="%"
        />
        <Slider
          label="Effective Tax Rate"
          id="tax-rate"
          value={taxRate}
          onInputChange={(e) => setTaxRate(e.target.value)}
          min={0}
          max={100}
          suffix="%"
        />

        <TermSelection />
      </div>
    </fieldset>
  )
}
